import { CookieNotice } from '@module/CookieNotice/CookieNotice';
import { setCookieNotice } from '@js/utils/cookieConsent';

const cookieNotice = new CookieNotice();

setCookieNotice(cookieNotice);


export { cookieNotice };
